<app-environment-ribbon />
@if (!authService.isAuthReady()) {
<div
  class="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-primary/30 via-accent/20 to-secondary/20 animate-gradient-move px-4"
>
  <div class="mb-6">
    <span
      class="inline-block animate-bounce text-6xl md:text-7xl drop-shadow-lg"
      >🚚</span
    >
  </div>
  <h1
    class="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent animate-text-shine text-center"
  >
    Haulverse is Loading...
  </h1>
  <p
    class="text-base xs:text-lg sm:text-xl text-primary-foreground/80 font-semibold mb-8 animate-fade-in text-center"
  >
    Buckle up! We're fueling up your fleet experience.
  </p>
  <div class="flex gap-2">
    <span
      class="w-3 h-3 md:w-4 md:h-4 rounded-full bg-primary animate-pulse"
    ></span>
    <span
      class="w-3 h-3 md:w-4 md:h-4 rounded-full bg-accent animate-pulse [animation-delay:0.2s]"
    ></span>
    <span
      class="w-3 h-3 md:w-4 md:h-4 rounded-full bg-secondary animate-pulse [animation-delay:0.4s]"
    ></span>
  </div>
</div>
} @else {
<router-outlet />
<!-- This single line enables the modal system for the entire app -->
<app-modal-host />
<!-- Non-disruptive deployment update banner -->
<app-update-banner />
<!-- Global runtime loading overlay -->
@if (loadingService.state().isVisible) {
<app-loading />
} }
